
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mining",
      function () {
        return require("private-next-pages/mining/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mining"])
      });
    }
  